import React from 'react'
import PropTypes from 'prop-types'

const THREAD_COLOR_OPTIONS = [
    { value: 'WHITE', name: 'TRẮNG', label: 'WHITE', swatch: '#ffffff' },
    { value: 'BLACK', name: 'ĐEN', label: 'BLACK', swatch: '#1f1f1f' },
    { value: 'GREY', name: 'GHI', label: 'GREY', swatch: '#9a9a9a' },
    { value: 'RED', name: 'ĐỎ', label: 'RED', swatch: '#e02020' },
]

const DEFAULT_ALLOWED_COLORS = ['WHITE', 'BLACK', 'GREY']

const ThreadColorSelect = ({ value, currentColor, allowedColors, onChange, disabled }) => {
    return (
        <div className="ThreadColorSelect">
            {THREAD_COLOR_OPTIONS.map(opt => {
                const isCurrent = currentColor === opt.value
                const isPicked = !isCurrent && value === opt.value
                const effectiveAllowedColors = Array.isArray(allowedColors) ? allowedColors : DEFAULT_ALLOWED_COLORS
                const isNotAllowed = !effectiveAllowedColors.includes(opt.value)
                const isDisabled = disabled || isNotAllowed
                const stateClass = isCurrent ? 'ColorSwatchCard--current' : isPicked ? 'ColorSwatchCard--picked' : ''
                const disabledClass = isNotAllowed ? 'ColorSwatchCard--disabled' : ''
                return (
                    <div
                        key={opt.value}
                        className={`ColorSwatchCard ${stateClass} ${disabledClass}`}
                        onClick={() => !isDisabled && onChange(opt.value)}
                    >
                        <span className="ColorSwatchCard__swatch" style={{ backgroundColor: opt.swatch }} />
                        <span className="ColorSwatchCard__name">{opt.name}</span>
                        <span className="ColorSwatchCard__label">{opt.label}</span>
                        {isCurrent && <span className="ColorSwatchCard__badge ColorSwatchCard__badge--current">✓ ĐANG CHỈ ĐỊNH</span>}
                        {isPicked && <span className="ColorSwatchCard__badge ColorSwatchCard__badge--picked">ĐÃ CHỌN</span>}
                    </div>
                )
            })}
        </div>
    )
}

ThreadColorSelect.propTypes = {
    value: PropTypes.string,
    currentColor: PropTypes.string,
    allowedColors: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default ThreadColorSelect
